import {
  PosCategory,
  PosProduct,
  RecentPosOrder,
  WorkspaceSummary,
} from '@adminpages/domain-models';

export const mockWorkspaces: WorkspaceSummary[] = [
  {
    id: 2,
    name: 'Universo Infantil',
    slug: 'universo-infantil',
    currency: 'MXN',
    themeKey: 'universo',
    capabilities: { pos: true, repairs: false, cash: true },
    homeRoute: '/pos',
  },
  {
    id: 3,
    name: 'Pollos Taly',
    slug: 'pollos-taly',
    currency: 'MXN',
    themeKey: 'taly',
    capabilities: { pos: true, repairs: false, cash: true },
    homeRoute: '/pos',
  },
];

export const mockCategories: PosCategory[] = [
  { id: 0, name: 'Todos', slug: 'todos' },
  { id: 4, name: 'Kits', slug: 'kits' },
  { id: 1, name: 'Etiquetas escolares', slug: 'etiquetas-escolares' },
  { id: 3, name: 'Botes y termos', slug: 'botes-y-termos' },
  { id: 2, name: 'Libretas personalizadas', slug: 'libretas-personalizadas' },
  { id: 7, name: 'Comida rápida', slug: 'comida-rapida' },
];

export const mockProducts: PosProduct[] = [
  {
    id: 60,
    sku: 'KIT-000011',
    slug: 'kit-basico-etiquetas',
    name: 'Kit Básico Etiquetas',
    type: 'bundle',
    categorySlug: 'kits',
    price: 199,
    currency: 'MXN',
    unit: 'kit',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 5, name: 'Resistente al agua', priceDelta: 100 },
      { id: 8, name: 'Diseño 100% personalizado', priceDelta: 100 },
    ],
    bundleComponents: [
      { name: 'Etiquetas rectangulares para lápices y colores', quantity: 40, unit: 'pieza' },
      { name: 'Etiquetas rectangulares', quantity: 10, unit: 'pieza' },
      { name: 'Etiquetas circulares 5x5', quantity: 10, unit: 'pieza' },
    ],
  },
  {
    id: 61,
    sku: 'KIT-000012',
    slug: 'kit-school-etiquetas',
    name: 'Kit School Etiquetas',
    type: 'bundle',
    categorySlug: 'kits',
    price: 349,
    currency: 'MXN',
    unit: 'kit',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 6, name: 'Resistente al agua', priceDelta: 100 },
      { id: 7, name: 'Laminado holográfico', priceDelta: 100 },
      { id: 9, name: 'Diseño 100% personalizado', priceDelta: 100 },
    ],
    bundleComponents: [
      { name: 'Etiquetas rectangulares para lápices y colores', quantity: 40, unit: 'pieza' },
      { name: 'Franja para libretas sin laminar', quantity: 9, unit: 'pieza' },
      { name: 'Etiquetas rectangulares', quantity: 10, unit: 'pieza' },
      { name: 'Etiquetas circulares 5x5', quantity: 10, unit: 'pieza' },
    ],
  },
  {
    id: 62,
    sku: 'KIT-000013',
    slug: 'kit-pro-etiquetas',
    name: 'Kit Pro Etiquetas',
    type: 'bundle',
    categorySlug: 'kits',
    price: 479,
    currency: 'MXN',
    unit: 'kit',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 10, name: 'Diseño 100% personalizado', priceDelta: 100 },
      { id: 11, name: 'Resistente al agua', priceDelta: 100 },
      { id: 12, name: 'Laminado holográfico', priceDelta: 100 },
    ],
    bundleComponents: [
      { name: 'Etiquetas circulares 5x5', quantity: 10, unit: 'pieza' },
      { name: 'Etiqueta siluetada con nombre vinil y laminado holográfico', quantity: 10, unit: 'pieza' },
      { name: 'Etiquetas rectangulares para lápices y colores', quantity: 40, unit: 'pieza' },
      { name: 'Franja para libretas sin laminar', quantity: 9, unit: 'pieza' },
      { name: 'Etiquetas rectangulares', quantity: 10, unit: 'pieza' },
    ],
  },
  {
    id: 57,
    sku: 'SERV-000005',
    slug: 'etiquetas-rectangulares-para-lapices-y-colores',
    name: 'Etiquetas rectangulares para lápices y colores',
    type: 'service',
    categorySlug: 'etiquetas-escolares',
    price: 3,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: false,
    stockQuantity: 0,
    addons: [{ id: 4, name: 'Resistentes al agua', priceDelta: 100 }],
    bundleComponents: [],
  },
  {
    id: 6,
    sku: 'PROD-000001',
    barcode: '842815138895',
    slug: 'termo-reduce-cold1-40oz-118l',
    name: 'Termo Reduce Cold1 40oz 1.18L',
    type: 'product',
    categorySlug: 'botes-y-termos',
    price: 399,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 2,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 15,
    sku: 'PROD-000010',
    barcode: '847280091386',
    slug: 'owala-12oz-spout-rosa',
    name: 'Owala 12oz Spout Rosa',
    type: 'product',
    categorySlug: 'botes-y-termos',
    price: 450,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 1,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 201,
    sku: 'POLLO-ENTERO',
    slug: 'pollo-entero',
    name: 'Pollo entero rostizado',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 185,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 301, name: 'Salsa extra', priceDelta: 10 },
      { id: 302, name: 'Tortillas extra', priceDelta: 15 },
    ],
    bundleComponents: [],
  },
  {
    id: 202,
    sku: 'COMBO-FAMILIAR',
    slug: 'combo-familiar',
    name: 'Combo familiar Taly',
    type: 'bundle',
    categorySlug: 'comida-rapida',
    price: 299,
    currency: 'MXN',
    unit: 'combo',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 303, name: 'Refresco 2L', priceDelta: 45 },
      { id: 304, name: 'Papas grandes', priceDelta: 55 },
    ],
    bundleComponents: [
      { name: 'Pollo entero rostizado', quantity: 1, unit: 'pieza' },
      { name: 'Arroz', quantity: 1, unit: 'orden' },
      { name: 'Salsa', quantity: 2, unit: 'pieza' },
    ],
  },
  {
    id: 203,
    sku: 'MEDIO-POLLO',
    slug: 'medio-pollo',
    name: 'Medio pollo rostizado',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 98,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 305, name: 'Salsa extra', priceDelta: 10 },
      { id: 306, name: 'Tortillas extra', priceDelta: 15 },
    ],
    bundleComponents: [],
  },
  {
    id: 204,
    sku: 'CUARTO-POLLO',
    slug: 'cuarto-pollo',
    name: 'Cuarto de pollo',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 58,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: false,
    stockQuantity: 0,
    addons: [{ id: 307, name: 'Salsa extra', priceDelta: 10 }],
    bundleComponents: [],
  },
  {
    id: 205,
    sku: 'ARROZ-ORDEN',
    slug: 'arroz-orden',
    name: 'Orden de arroz',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 35,
    currency: 'MXN',
    unit: 'orden',
    trackStock: false,
    stockQuantity: 0,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 206,
    sku: 'PAPAS-CHICAS',
    slug: 'papas-chicas',
    name: 'Papas chicas',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 42,
    currency: 'MXN',
    unit: 'orden',
    trackStock: false,
    stockQuantity: 0,
    addons: [{ id: 308, name: 'Aderezo extra', priceDelta: 8 }],
    bundleComponents: [],
  },
  {
    id: 207,
    sku: 'PAPAS-GRANDES',
    slug: 'papas-grandes',
    name: 'Papas grandes',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 62,
    currency: 'MXN',
    unit: 'orden',
    trackStock: false,
    stockQuantity: 0,
    addons: [{ id: 309, name: 'Aderezo extra', priceDelta: 8 }],
    bundleComponents: [],
  },
  {
    id: 208,
    sku: 'REFRESCO-600',
    barcode: '7500000000600',
    slug: 'refresco-600',
    name: 'Refresco 600 ml',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 28,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 24,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 209,
    sku: 'REFRESCO-2L',
    barcode: '7500000002000',
    slug: 'refresco-2l',
    name: 'Refresco 2 litros',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 45,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 12,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 210,
    sku: 'COMBO-INDIVIDUAL',
    slug: 'combo-individual',
    name: 'Combo individual',
    type: 'bundle',
    categorySlug: 'comida-rapida',
    price: 129,
    currency: 'MXN',
    unit: 'combo',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 310, name: 'Refresco 600 ml', priceDelta: 28 },
      { id: 311, name: 'Papas chicas', priceDelta: 42 },
    ],
    bundleComponents: [
      { name: 'Cuarto de pollo', quantity: 1, unit: 'pieza' },
      { name: 'Arroz', quantity: 1, unit: 'orden' },
      { name: 'Tortillas', quantity: 1, unit: 'paquete' },
    ],
  },
  {
    id: 211,
    sku: 'COMBO-PAREJA',
    slug: 'combo-pareja',
    name: 'Combo pareja',
    type: 'bundle',
    categorySlug: 'comida-rapida',
    price: 219,
    currency: 'MXN',
    unit: 'combo',
    trackStock: false,
    stockQuantity: 0,
    addons: [{ id: 312, name: 'Refresco 2L', priceDelta: 45 }],
    bundleComponents: [
      { name: 'Medio pollo rostizado', quantity: 1, unit: 'pieza' },
      { name: 'Papas chicas', quantity: 1, unit: 'orden' },
      { name: 'Salsa', quantity: 2, unit: 'pieza' },
    ],
  },
  {
    id: 212,
    sku: 'SALSA-EXTRA',
    slug: 'salsa-extra',
    name: 'Salsa extra',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 10,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: false,
    stockQuantity: 0,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 213,
    sku: 'TORTILLAS-EXTRA',
    slug: 'tortillas-extra',
    name: 'Tortillas extra',
    type: 'product',
    categorySlug: 'comida-rapida',
    price: 15,
    currency: 'MXN',
    unit: 'paquete',
    trackStock: false,
    stockQuantity: 0,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 64,
    sku: 'SERV-000009',
    slug: 'etiquetas-para-crayolas-normal',
    name: 'Etiquetas para crayolas normal',
    type: 'service',
    categorySlug: 'etiquetas-escolares',
    price: 150,
    currency: 'MXN',
    unit: 'paquete',
    trackStock: false,
    stockQuantity: 0,
    addons: [
      { id: 13, name: 'Laminado holográfico', priceDelta: 50 },
      { id: 14, name: 'Resistente al agua', priceDelta: 50 },
    ],
    bundleComponents: [],
  },
  {
    id: 65,
    sku: 'SERV-000010',
    slug: 'franja-libreta-holografica',
    name: 'Franja libreta holográfica',
    type: 'service',
    categorySlug: 'etiquetas-escolares',
    price: 31,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: false,
    stockQuantity: 0,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 66,
    sku: 'PROD-000024',
    slug: 'libreta-profesional-norma-cocida',
    name: 'Libreta profesional Norma cocida',
    type: 'product',
    categorySlug: 'libretas-personalizadas',
    price: 80,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 13,
    addons: [
      { id: 15, name: 'Forro clásico', priceDelta: 70 },
      { id: 16, name: 'Forro personalizado', priceDelta: 95 },
    ],
    bundleComponents: [],
  },
  {
    id: 67,
    sku: 'KIT-000014',
    slug: 'paquete-forros-libreta-clasico',
    name: 'Paquete Forros Libreta Clásico',
    type: 'bundle',
    categorySlug: 'kits',
    price: 350,
    currency: 'MXN',
    unit: 'paquete',
    trackStock: false,
    stockQuantity: 0,
    addons: [{ id: 17, name: 'Diseño personalizado', priceDelta: 100 }],
    bundleComponents: [{ name: 'Forro de libreta clásico', quantity: 5, unit: 'pieza' }],
  },
  {
    id: 68,
    sku: 'KIT-000015',
    slug: 'paquete-forros-holografico',
    name: 'Paquete Forros Holográfico',
    type: 'bundle',
    categorySlug: 'kits',
    price: 425,
    currency: 'MXN',
    unit: 'paquete',
    trackStock: false,
    stockQuantity: 0,
    addons: [],
    bundleComponents: [{ name: 'Forro libreta semipersonalizado', quantity: 5, unit: 'pieza' }],
  },
  {
    id: 69,
    sku: 'KIT-000016',
    slug: 'paquete-forros-100-personalizado',
    name: 'Paquete Forros 100% Personalizado',
    type: 'bundle',
    categorySlug: 'kits',
    price: 475,
    currency: 'MXN',
    unit: 'paquete',
    trackStock: false,
    stockQuantity: 0,
    addons: [],
    bundleComponents: [{ name: 'Forro libreta exclusivo', quantity: 5, unit: 'pieza' }],
  },
  {
    id: 70,
    sku: 'PROD-000025',
    barcode: '847280091386',
    slug: 'owala-12oz-spout-azul-cielo',
    name: 'Owala 12oz Spout Azul Cielo',
    type: 'product',
    categorySlug: 'botes-y-termos',
    price: 450,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 1,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 71,
    sku: 'PROD-000026',
    barcode: '847280091386',
    slug: 'owala-original-32-oz-945-ml-varios-colores',
    name: 'Owala original 32 OZ 945 ml varios colores',
    type: 'product',
    categorySlug: 'botes-y-termos',
    price: 590,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 2,
    addons: [],
    bundleComponents: [],
  },
  {
    id: 72,
    sku: 'PROD-000027',
    slug: 'lonchera-toy-story-jessie',
    name: 'Lonchera Toy Story Jessie',
    type: 'product',
    categorySlug: 'botes-y-termos',
    price: 170,
    currency: 'MXN',
    unit: 'pieza',
    trackStock: true,
    stockQuantity: 1,
    addons: [{ id: 18, name: 'Personalización nombre', priceDelta: 80 }],
    bundleComponents: [],
  },
];

export const mockRecentOrders: RecentPosOrder[] = [
  {
    uuid: '2a1d1d6f-b590-4f4e-8c16-000000000001',
    folio: 'PED-2026-00042',
    customerName: 'Publico en general',
    source: 'pos',
    status: 'confirmed',
    paymentStatus: 'paid',
    total: 199,
    paidTotal: 199,
    balanceDue: 0,
    method: 'cash',
    createdAt: 'Hoy 10:35',
    items: [
      { id: 1, name: 'Kit Basico Etiquetas', quantity: 1, unitPrice: 199, total: 199, addons: [] },
    ],
    payments: [
      { id: 1, type: 'payment', method: 'cash', amount: 199, status: 'approved' },
    ],
  },
  {
    uuid: '2a1d1d6f-b590-4f4e-8c16-000000000002',
    folio: 'PED-2026-00043',
    customerName: 'Cliente Anticipo POS',
    source: 'pos',
    status: 'quoted',
    paymentStatus: 'partial',
    total: 349,
    paidTotal: 100,
    balanceDue: 249,
    method: 'transfer',
    createdAt: 'Hoy 11:12',
    items: [
      { id: 2, name: 'Kit School Etiquetas', quantity: 1, unitPrice: 349, total: 349, addons: [] },
    ],
    payments: [
      { id: 2, type: 'deposit', method: 'transfer', amount: 100, status: 'approved' },
    ],
  },
];
